import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const CardMedia = ({ children, className, tag: Tag, ...props }) => (
  <Tag className={classnames('card-media', className)} {...props}>
    {children}
  </Tag>
);

CardMedia.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tag: PropTypes.node,
};

CardMedia.defaultProps = {
  children: null,
  className: null,
  tag: 'div',
};

export default CardMedia;
